import { useContext } from 'react'
import { Trans, useTranslation as useTranslationOriginal } from 'react-i18next'

import RootContext from '../RootContext'

const useTranslation = () => {
  const { t: originalT } = useTranslationOriginal()

  const { t, trans } = useContext(RootContext)

  return {
    t: t ?? originalT,
    trans: trans || Trans,
  }
}

export default useTranslation
